import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getBarBookings, getBars } from '../../actions/bar';

const AllBarBookings = ({ getBarBookings, getBars, auth, bar: {bookings, bars} }) => {

  useEffect(() => {
      getBars();
  }, [getBars])

  useEffect(() => {
    getBarBookings();
}, [getBarBookings])

  return (
    <div className='container'>
        <h4><i className='fa-light fa-receipt' style={{color: 'var(--primary-color)'}} />&nbsp;All Bookings</h4>
        {bookings.map((b) => (

            <div className='bs container' style={{ maxWidth: '90%'}} key={b._id}>
          
            <Row>
                <Col style={{padding: '10px'}}>
                {bars.map(bar => bar._id === b.barid && 
                    <>
                        <Row><img src={bar.imageurl[0]} alt = 'bar img' /></Row>
                        <Row><Col>Bar: {bar.name}</Col><Col style={{textAlign: 'right'}}>Type: Bar</Col></Row>
                    </>
                )}
                </Col>
                <Col style={{padding: '10px'}}>
                    <h6>Booking Details</h6>
                    <Row><Col>Guest Name</Col><Col>{b.name}</Col></Row>
                    <Row><Col>Mobile</Col><Col>{b.mobile}</Col></Row>
                    <Row><Col>Duration</Col><Col>1 Day</Col></Row>
                    <Row><Col>Booking For</Col><Col>{moment(b.dateon, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
                    <Row><Col>Coupon</Col><Col>{b.couponcode && <>{b.couponcode}</>} {!b.couponcode && <>Not Applied</>}</Col></Row>
                    <Row><Col>Amount</Col><Col><b><i className='fa fa-indian-rupee'></i>&nbsp;{b.totalamount}</b></Col></Row>
                </Col>
                <Col style={{padding: '10px'}}>
                    <h6>Booking Status</h6>
                    <Row>
                        <Col>Status</Col>
                        <Col>
                            {b.status === 'saved' && <h6 style={{color: 'var(--danger-color)', border:'dashed 1px var(--danger-color)'}}><center>Not Confirmed</center></h6>}
                            {b.status === 'cancelled' && <h6 style={{color: 'var(--primary-color)', border:'dashed 1px var(--primary-color)'}}><center>Cancelled</center></h6>}
                            {b.status === 'confirmed' && <h6 style={{color: 'var(--success-color)', border: 'dashed 1px var(--success-color)'}}><center>Confirmed</center></h6>}
                        </Col>
                    </Row>
                    { b.status === 'confirmed' &&
                        <Row><Col>Transaction Id</Col><Col>{b.transactionid ==='default' ? <>Not yet paid</> : <>{b.transactionid}</> }</Col></Row>
                    }
            </Col>
          </Row>
        </div>
      ))}
    </div>
  )
};

AllBarBookings.propTypes = {
    bar: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
    getBars: propTypes.func.isRequired,
    getBarBookings: propTypes.func.isRequired
};

const mapStateToProps = state => ({
  bar: state.bar,
  auth: state.auth
});

export default connect(mapStateToProps, { getBarBookings, getBars})(AllBarBookings);